import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'

export function ContactHeroSection() {
  return (
    <Section surface="0" className="pt-10 pb-8 sm:pt-16 sm:pb-12 md:pt-24 md:pb-16">
      <Container className="max-w-4xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Initiate Contact
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-fg text-balance leading-tight">
          Let's Discuss Your Project Specifications.
        </h1>
        <p className="mt-4 sm:mt-6 text-sm sm:text-lg md:text-xl text-fg-subtle leading-relaxed">
          Reach out directly to establish project scoping, request engineering proposals, or arrange an exploratory consultation.
        </p>
      </Container>
    </Section>
  )
}
